import { render, staticRenderFns } from "./EventEmail.vue?vue&type=template&id=4aa9bae5&scoped=true&"
import script from "./EventEmail.vue?vue&type=script&lang=js&"
export * from "./EventEmail.vue?vue&type=script&lang=js&"
import style0 from "./EventEmail.vue?vue&type=style&index=0&id=4aa9bae5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa9bae5",
  null
  
)

export default component.exports